import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import styles from './multiSelectCheckbox.module.scss';
import i18n from 'i18n';
import cx from 'classnames/bind';

export type MultiSelectCheckboxProps = {
  title?: string;
  options: SelectOptions[];
  values?: (string | number)[];
  className?: string;
  // opt-in 單選模式：預設維持多選（既有使用者不受影響）。開啟 'single' 時
  // 「外觀維持 checkbox」，只改選取邏輯——勾一個就清掉其他，永遠只有一個被勾。
  selectionMode?: 'single' | 'multi';
  onApply: (values: (string | number)[]) => void;
  onClose: () => void;
};

export const MultiSelectCheckbox: React.FC<MultiSelectCheckboxProps> = (
  props
) => {
  const [values, setValues] = useState(props.values ? props.values : []);
  const classNames = cx.bind(styles);
  const isSingle = props.selectionMode === 'single';

  useEffect(() => {
    setValues(props.values ? props.values : []);
  }, [props.values]);

  const onSelect = (value) => {
    if (isSingle) {
      // 單選：只保留這次點的值（強制單勾），視覺上永遠只有一個 checkbox 打勾
      setValues([value]);
      return;
    }
    if (values.includes(value)) {
      setValues((prevValues) =>
        _.filter(prevValues, (prevValue) => prevValue !== value)
      );
    } else {
      setValues((prevValues) => [...prevValues, value]);
    }
  };

  const onApply = () => {
    props.onApply(values);
  };

  const renderCheckItems = () => {
    return props.options.map((option) => (
      <li key={option.value}>
        <input
          type='checkbox'
          checked={values.includes(option.value)}
          onChange={_.partial(onSelect, option.value)}
          id={`input${option.value}`}
        />
        <label htmlFor={`input${option.value}`}>{option.label}</label>
      </li>
    ));
  };

  const multiSelectCheckboxClassName = classNames(
    'multiSelectCheckbox',
    props.className
  );
  return (
    <div className={multiSelectCheckboxClassName}>
      <div>
        {props.title && <div className={styles.title}>{props.title}</div>}
        <ul>{renderCheckItems()}</ul>
      </div>
      <div className={styles.buttonArea}>
        <Button className={styles.miniButton} size='sm' onClick={onApply}>
          {i18n.t('common.buttons.apply')}
        </Button>
        <Button
          className={styles.miniButton}
          variant='secondary'
          size='sm'
          onClick={props.onClose}
        >
          {i18n.t('common.buttons.cancel')}
        </Button>
      </div>
    </div>
  );
};
